import { useAuth } from 'contexts/auth';
import { useState } from 'react';
import batchRequests from 'services/batch';
import { FileUpload, Text, styled } from 'shell/components';
import { uploadFile } from 'utils/file';

const FileParserDemo = () => {
    const { auth } = useAuth();
    const [pdfText, setPdfText] = useState('');

    const onDocumentLoadSuccess = async (file) => {
        uploadFile(
            file[0],
            () => {},
            async (data) => {
                // Example data is {bucket: "ensightful-us-upload-app-sandbox", key: "aa-bb-cc-dd",name: "picture in between.pdf",type: "application/pdf"}
                // const getParsedFile = await fileRequests.parseFile({ file: data });
                const getParsedFile = await batchRequests.createSubmissions(auth.course_id, [
                    { owner_account_id: auth.owner_account_id, course_id: auth.course_id, data: data },
                ]);                
                setPdfText(getParsedFile);
            },
            (e) => console.error('File upload failed.', e),
            auth.owner_account_id
        );
    };

    return (
        <>
            <Text variant={'sh1'}>File Parser</Text>
            {!auth?.owner_account_id && <Text color={'error'}>Need to be in a course</Text>}
            <FileUpload onChange={onDocumentLoadSuccess} />
            <StyledText>{pdfText}</StyledText>
        </>
    );
};

const StyledText = styled(Text)(() => {
    return {
        whiteSpace: 'pre-line',
    };
});

export default FileParserDemo;
